import styled from 'styled-components'
import ModalLayout from './common/ModalLayout'
import Text from '../atoms/Text'
import MainButton from '../atoms/MainButton'

const TextWrapper = styled.div`
  text-align: left;
`
const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  gap: 8px;
`

const EditModal = ({ onClose, onConfirm }) => {
  return (
    <ModalLayout>
      <>
        <TextWrapper>
          <Text>오타가 있을 때만 수정해주세요. <br/>
                의미단어를 추가하려면 새로 작성해주세요</Text>
        </TextWrapper>
        <ButtonWrapper>
          <MainButton
            $variant="cancel"
            $size="small"
            title="취소"
            onClick={onClose}/>
          <MainButton
            $variant="primary"
            $size="small"
            title="수정"
            onClick={onConfirm}/>
        </ButtonWrapper>
      </>
    </ModalLayout>
  )
}

export default EditModal
